import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '../shared/styles.css';
import { ToastProvider } from '../shared/ui';
import { PortalApp } from './PortalApp';

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <PortalApp />
      </ToastProvider>
    </BrowserRouter>
  </StrictMode>,
);
